import React from 'react'
import Navbar from "./Navbar";
import DashboardWrapper from './DashboardWrapper';
function Dashboard() {
  return (
    <div  style={{ width: "100%" , direction:"rtl" }}>
    <Navbar />
    <DashboardWrapper />

    </div>  )
}

export default Dashboard